import Fuse from 'fuse.js';
import _isEmpty from 'lodash/isEmpty';

class FuzzySearch {
  constructor(
    options = [],
    keys = [],
    { threshold = 0.5, minMatchCharLength = 1, ignoreWordOrder = true, shouldSort = true } = {},
  ) {
    this.ignoreWordOrder = ignoreWordOrder;
    this.minMatchCharLength = minMatchCharLength;
    this.options = options;
    this.fuse = new Fuse(options, {
      keys,
      threshold,
      minMatchCharLength,
      useExtendedSearch: !!ignoreWordOrder,
      shouldSort,
    });
  }

  search(query = '') {
    if (query.length < this.minMatchCharLength) {
      return [];
    }

    if (_isEmpty(query.trim())) {
      return this.options;
    }

    const finalQuery = this.ignoreWordOrder ? query.trim().split(' ').join(" '") : query;

    return this.fuse.search(finalQuery).map((result) => result.item);
  }
}

export { FuzzySearch };
